import { IState } from './iState';
import { ActionTypeMix, SET_USER } from './types';

export const setUser = (storage: IState): ActionTypeMix => ({
  type: SET_USER,
  value: storage,
});